module.exports = __webpack_public_path__ + "statics/img/3.9e63967.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/3.jpg
// module id = Mqb5
// module chunks = 1